import { useState, useContext, useEffect, useMemo } from "react";
import StateContext from "../../state/stateContext";
import Shimmer from "../Shimmer/Shimmer";
import useQueryCommunityNews from "../Hooks/useQueryCommunityNews";
import useQueryChildData from "../Hooks/useQueryChildData";
import useQueryCommitment from "../Hooks/useQueryCommitment";

export function wrapAuthData(WrappedComponent, opts = {}) {
  const { 
    shimmerProps: shimmerDefaultProps={}, 
    requires: requiresDefault=[],
    name,
  } = opts;
  return (props) => {
    const { shimmerProps=shimmerDefaultProps, FallbackComponent=() => null, requires=requiresDefault, ...componentProps } = props;
    const context = useContext(StateContext);
    const queryCommitment = useQueryCommitment(context);
    const queryChildData = useQueryChildData(context);
    const queryCommunityNews = useQueryCommunityNews(context);
    const requiresData = [].concat(requires);
    const queryObjects = {
      "communityNews": queryCommunityNews,
      "commitment": queryCommitment,
      "child": queryChildData,
    };

    const isWaiting = requiresData.some(key => {
      return !!queryObjects?.[key]?.isWaiting;
    });

    const isError = requiresData.some(key => {
      return !!queryObjects?.[key]?.isError;
    });

    const showShimmer = isWaiting;

    if (isError) {
      return <FallbackComponent {...componentProps} />;
    }

    if (showShimmer) {
      return (
          <Shimmer 
            className={`${shimmerProps?.classList || ""}`}
            isLoading={true}
            height={shimmerProps.height}
            {...shimmerProps}
          />
      );
    }

    const requiredData = requiresData.reduce((all, key) => {
      return {
        ...all,
        [key]: queryObjects[key]?.data
      };
    }, {});

    return (
      <WrappedComponent {...componentProps } requiredData={requiredData} />
    )
  }
}